type SignupReviewSectionProps = {
  title: string
  description: string
  editLabel: string
  personalTitle: string
  contactTitle: string
  addressTitle: string
  personalRows: Array<{ label: string; value: string }>
  contactRows: Array<{ label: string; value: string }>
  addressRows: Array<{ label: string; value: string }>
  onEditPersonal: () => void
  onEditContact: () => void
}

const ReviewGroup = ({
  title,
  rows,
  editLabel,
  onEdit,
}: {
  title: string
  rows: Array<{ label: string; value: string }>
  editLabel: string
  onEdit: () => void
}) => (
  <section className="space-y-3 border-b border-[color-mix(in_srgb,var(--color-border-default)_82%,transparent)] pb-4 last:border-b-0 last:pb-0">
    <div className="flex items-center justify-between gap-3">
      <h3 className="text-sm font-semibold text-(--color-text-primary)">{title}</h3>
      <button
        type="button"
        onClick={onEdit}
        className="text-xs font-semibold text-(--color-action-primary) hover:text-(--color-focus-ring) focus-visible:outline-none"
      >
        {editLabel}
      </button>
    </div>
    <dl className="grid gap-x-4 gap-y-2 sm:grid-cols-2">
      {rows.map((row) => (
        <div key={`${title}-${row.label}`} className="space-y-0.5">
          <dt className="text-xs text-(--color-text-muted)">{row.label}</dt>
          <dd className="text-sm font-medium text-(--color-text-primary)">{row.value}</dd>
        </div>
      ))}
    </dl>
  </section>
)

export const SignupReviewSection = ({
  title,
  description,
  editLabel,
  personalTitle,
  contactTitle,
  addressTitle,
  personalRows,
  contactRows,
  addressRows,
  onEditPersonal,
  onEditContact,
}: SignupReviewSectionProps) => (
  <section className="space-y-5">
    <div className="space-y-1.5">
      <h2 className="text-base font-semibold tracking-tight text-(--color-text-primary)">{title}</h2>
      <p className="text-sm leading-relaxed text-(--color-text-secondary)">{description}</p>
    </div>
    <div className="space-y-4">
      <ReviewGroup title={personalTitle} rows={personalRows} editLabel={editLabel} onEdit={onEditPersonal} />
      <ReviewGroup title={contactTitle} rows={contactRows} editLabel={editLabel} onEdit={onEditContact} />
      <ReviewGroup title={addressTitle} rows={addressRows} editLabel={editLabel} onEdit={onEditContact} />
    </div>
  </section>
)
